import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../contexts/AuthContext';
import { Lock, Loader2 } from 'lucide-react';

// Simple session cache to avoid repeated API calls during navigation
const MODULE_CACHE = { data: null, ts: 0 };
const CACHE_TTL = 60_000; // 1 minute

async function getModules() {
  if (MODULE_CACHE.data && Date.now() - MODULE_CACHE.ts < CACHE_TTL) {
    return MODULE_CACHE.data;
  }
  const res = await axios.get(`${API}/admin/my-modules`);
  MODULE_CACHE.data = res.data;
  MODULE_CACHE.ts = Date.now();
  return res.data;
}

// Call this to force-refresh after toggling a module in SuperAdmin
export function clearModuleCache() {
  MODULE_CACHE.data = null;
  MODULE_CACHE.ts = 0;
}

export default function ModuleGate({ module: moduleName, children }) {
  const [enabled, setEnabled] = useState(null);

  useEffect(() => {
    getModules()
      .then(data => setEnabled(data?.[moduleName] !== false))
      .catch(() => setEnabled(true)); // fail-open on error
  }, [moduleName]);

  if (enabled === null) return (
    <div className="flex justify-center py-16">
      <Loader2 className="animate-spin text-primary" size={28} />
    </div>
  );

  if (!enabled) return (
    <div className="flex flex-col items-center justify-center py-24 gap-5 text-center"
      data-testid="module-locked">
      <div className="w-16 h-16 rounded-2xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
        <Lock size={28} className="text-amber-600 dark:text-amber-400" />
      </div>
      <div>
        <h2 className="text-xl font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Modulo non attivo
        </h2>
        <p className="text-muted-foreground mt-1 max-w-md text-sm">
          Questo modulo non è attivo per la tua azienda. Contatta il Super Admin per abilitarlo.
        </p>
      </div>
    </div>
  );

  return children;
}
